import { lazy } from 'react';

const PolicyholdersRoutes = [
  {
    path: 'insurer',
    component: lazy(() => import('pages/insurer')),
  },
];

export default PolicyholdersRoutes;
